var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import SpsCardHeader from './SpsCardHeader';
import classnames from "classnames";

export var SpsCard = function (_Component) {
  _inherits(SpsCard, _Component);

  function SpsCard(props) {
    _classCallCheck(this, SpsCard);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.setTabUsingActiveTab = function (childrenArr, activeTab) {
      for (var index = 0; index <= childrenArr.length; index++) {
        if (childrenArr[index].props && childrenArr[index].props.id != undefined && childrenArr[index].props.id === activeTab) {
          _this.setState({ activeTabContent: childrenArr[index].props.children, activeTabIndex: index });
          break;
        }
      }
    };

    _this.setInitialTabContent = function (childrenArr) {
      for (var _iterator = childrenArr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var child = _ref;

        var firstTab = child.props;
        _this.setState({ activeTabContent: firstTab.children });
        break;
      }
    };

    _this.activateTab = function (event, index, content) {
      _this.setState({ activeTabIndex: index, activeTabContent: content });
    };

    _this.state = {
      activeTabIndex: 0,
      activeTabContent: null
    };
    return _this;
  }

  SpsCard.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        children = _props.children,
        isTabbedCard = _props.isTabbedCard,
        activeTab = _props.activeTab;

    var childrenArr = React.Children.toArray(children);
    if (isTabbedCard && activeTab) {
      this.setTabUsingActiveTab(childrenArr, activeTab);
    } else if (isTabbedCard) {
      this.setInitialTabContent(childrenArr);
    }
  };

  SpsCard.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        headerTitle = _props2.headerTitle,
        headerContent = _props2.headerContent,
        headerIcon = _props2.headerIcon,
        footer = _props2.footer,
        isTabbedCard = _props2.isTabbedCard,
        className = _props2.className,
        rest = _objectWithoutProperties(_props2, ["children", "headerTitle", "headerContent", "headerIcon", "footer", "isTabbedCard", "className"]);

    var cardClasses = classnames("sps-card", className);
    var cardFooter = typeof footer === "function" ? footer : function () {
      return footer;
    };
    var cardHeader = typeof headerContent === "function" ? headerContent : function () {
      return headerContent;
    };

    return React.createElement(
      "div",
      { className: cardClasses },
      (headerTitle || headerContent) && React.createElement(
        SpsCardHeader,
        { title: headerTitle, content: cardHeader(), icon: headerIcon },
        " "
      ),
      isTabbedCard == true ? React.createElement(
        React.Fragment,
        null,
        React.createElement(
          "nav",
          { className: "sps-nav sps-nav--tabs", role: "tablist" },
          React.Children.map(children, function (child, index) {
            var tabActiveStatus = index === _this2.state.activeTabIndex ? "active" : "";
            if (typeof child.type == "function") {
              return React.cloneElement(child, { active: tabActiveStatus, index: index, activateTab: _this2.activateTab });
            }
          })
        ),
        React.createElement(
          "div",
          { className: "sps-card__body" },
          this.state.activeTabContent
        )
      ) : React.createElement(
        "div",
        _extends({ className: "sps-card__body" }, rest),
        children
      ),
      footer && React.createElement(
        "div",
        { className: "sps-card__footer" },
        cardFooter()
      )
    );
  };

  return SpsCard;
}(Component);

export default SpsCard;